import { Bar } from "@ant-design/plots";

// const data = [
//   { year: "1951 年", type: "type1", value: 1 },
//   { year: "1951 年", type: "type2", value: 33.33 },
//   { year: "1951 年", type: "type3", value: 100 },
//   { year: "1952 年", type: "type1", value: 52 },
//   { year: "1952 年", type: "type2", value: 42 },
//   { year: "1952 年", type: "type3", value: 72 },
//   // Add more data for each year and each type...
// ];

const ShapeChart = ({ data=[] }) => {
  console.log(data, "=data:ShapeChart:alq",);
  const config = {
    data,
    isGroup: true, // This enables grouped bars
    xField: "year",
    yField: "value",
    seriesField: "type",
    // colorField: "year",
    legend: false,
    tooltip: false,
    colorField: ["#FF8536", "green"],
  };
  return (
    <div>
      <h1 className="text-lg font-semibold">Marks Scored</h1>
      <div className="flex items-center justify-between">
        {/* <div className="space-y-3">
          <div className="flex items-center gap-2">
            <div className="rounded-sm bg-yellow w-[15px] h-[15px]" />
            <p>Marks</p>
          </div>
          <div className="flex items-center gap-2">
            <div className="rounded-sm bg-orange1 w-[15px] h-[15px]" />
            <p>Percentage</p>
          </div>
          <div className="flex items-center gap-2">
            <div className="rounded-sm bg-DarkGrey w-[15px] h-[15px]" />
            <p>Percentile</p>
          </div>
        </div> */}
        <Bar {...config} />
      </div>
    </div>
  );
};

export default ShapeChart;
